// Déduplication et détection du double rôle Client / Fournisseur.
// Niveau 1 : CIN ou téléphone identiques → exact
// Niveau 2 : nom exact (insensible casse + accents) → exact
// Niveau 3 : Levenshtein ≤ 2 sur le nom, ou téléphone à 1 chiffre près → ambigu

export const normNom = (v = '') =>
  String(v)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

export const normTel = (v = '') => {
  const chiffres = String(v).replace(/\D/g, '');
  return chiffres.replace(/^00?216/, '').replace(/^216/, '');
};

export const normCin = (v = '') => String(v).replace(/\D/g, '');

export const levenshtein = (a, b) => {
  if (a === b) return 0;
  const m = a.length;
  const n = b.length;
  if (!m || !n) return m || n;
  let prev = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i += 1) {
    const cur = [i];
    for (let j = 1; j <= n; j += 1) {
      cur[j] = Math.min(
        prev[j] + 1,
        cur[j - 1] + 1,
        prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
      );
    }
    prev = cur;
  }
  return prev[n];
};

const telProche = (a, b) => {
  if (!a || !b) return false;
  if (a.length === b.length) {
    let diff = 0;
    for (let i = 0; i < a.length; i += 1) if (a[i] !== b[i]) diff += 1;
    return diff === 1;
  }
  // Chiffre inséré ou supprimé : distance d'édition de 1.
  return Math.abs(a.length - b.length) === 1 && levenshtein(a, b) === 1;
};

// Retourne { niveau, type: 'exact'|'ambigu'|null, contact, motif }
export const rapprocher = (saisie, contacts) => {
  const nom = normNom(saisie.nom);
  const tel = normTel(saisie.tel);
  const cin = normCin(saisie.cin);

  const exact1 = contacts.find(
    (c) =>
      (cin && normCin(c.cin) && normCin(c.cin) === cin) ||
      (tel && normTel(c.tel) && normTel(c.tel) === tel)
  );
  if (exact1)
    return {
      niveau: 1,
      type: 'exact',
      contact: exact1,
      motif: cin && normCin(exact1.cin) === cin ? 'CIN identique' : 'Téléphone identique',
    };

  const exact2 = nom && contacts.find((c) => normNom(c.nom) === nom);
  if (exact2) return { niveau: 2, type: 'exact', contact: exact2, motif: 'Nom identique' };

  const partiel =
    contacts.find((c) => nom && normNom(c.nom) && levenshtein(normNom(c.nom), nom) <= 2) ??
    contacts.find((c) => telProche(normTel(c.tel), tel));
  if (partiel)
    return {
      niveau: 3,
      type: 'ambigu',
      contact: partiel,
      motif:
        nom && levenshtein(normNom(partiel.nom), nom) <= 2
          ? 'Nom très proche'
          : 'Téléphone à un chiffre près',
    };

  return { niveau: 0, type: null, contact: null, motif: null };
};
